import { activate } from "./activate.js";
import { setProductKey } from "./set-product-key.js";

export default {
  activate,
  setProductKey,
};
